import PropTypes from 'prop-types'

import WishlistItem from './WishlistItem'
import WishlistAddButton from './WishlistAddButton'
import shapePropTypes from './shapePropTypes'

const mobileWidth = 769

const WishlistCollection = ({ wishlists, onEdit, onCreate, onRemove }) => (
  <div className="container">
    <ul className="wishlist-collection">
      {
        wishlists && wishlists.map((item, index) => (
          <WishlistItem
            onEdit={onEdit}
            onRemove={onRemove}
            item={item}
            key={`item-${index}`} />
        ))
      }
      <WishlistAddButton onCreate={onCreate} />
    </ul>
  </div>
)

WishlistCollection.propTypes = {
  wishlists: PropTypes.arrayOf(PropTypes.shape({ ...shapePropTypes })).isRequired,
  onCreate: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
}

export default WishlistCollection
